import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class MultiSessionLimitConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	/**
	 * This config is under jurisdiction
	 */
	getMultiSessionLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.common.multiSessionLimit.endpoints!.multiSessionLimit,
			"v1/se/currentcustomerlimits/sessionlimit"
		);
	}

	/**
	 * This config is under jurisdiction
	 */
	getMultiSessionLimitEnabled(): boolean {
		return this.configService.get((x) => x.common.multiSessionLimit.isMultiSessionLimitEnabled, false);
	}

	getMultiSessionLimitSuffixed(): boolean {
		return this.configService.get((x) => x.common.multiSessionLimit.isMultiSessionLimitSuffixed, false);
	}
}
